const handler = {
  project: {
    value: ownerId => {
      return (dispatch, getState, opts) => {
        const {
          api
        } = opts;
        return api.project(ownerId);
      };
    },
    path: ownerId => {
      return `project/${ownerId}`;
    }
  },
  user: {
    value: ownerId => {
      return (dispatch, getState, opts) => {
        const {
          api
        } = opts;
        return api.user(ownerId);
      };
    },
    path: ownerId => {
      return `user/${ownerId}`;
    }
  },
  system: {
    value: (ownerId, coownerId, fallback) => {
      return (dispatch, getState, opts) => {
        const {
          api
        } = opts;
        if (fallback?.projectId) {
          return api.project(fallback?.projectId).system(ownerId);
        }
        return api.system(ownerId);
      };
    },
    path: ownerId => {
      return `system/${ownerId}`;
    }
  }
};
function handlerForFallback({
  ownerId,
  coownerId,
  ownerType,
  coownerType
}) {
  const owner = handler[ownerType];
  if (coownerType) {
    return owner?.coowner[coownerType];
  }
  return owner;
}
export default {
  handler,
  handlerForFallback
};